function filterprice(){
    var inputLeft = document.querySelector(".price-left");
    var inputRight = document.querySelector(".price-right");
    var amountLeft = document.querySelector(".amount-left .amount-percentage");
    var amountRight = document.querySelector(".amount-right .amount-percentage");
    var thumbLeft = document.querySelector(".price-slider > .thumb.left");
    var thumbRight = document.querySelector(".price-slider > .thumb.right");
    var range = document.querySelector(".price-slider > .range");
    function setLeftValue() {
        var _this = inputLeft,
            min = parseInt(_this.min),
            max = parseInt(_this.max);
        _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
        var percent = ((_this.value - min) / (max - min)) * 100;
        thumbLeft.style.left = percent + "%";
        amountLeft.innerHTML = _this.value;
        $('.textpriceleft').val(_this.value);
        range.style.left = percent + "%";
    }
    setLeftValue();
    function setRightValue() {
        var _this = inputRight,
            min = parseInt(_this.min),
            max = parseInt(_this.max);
        _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
        var percent = ((_this.value - min) / (max - min)) * 100;
        thumbRight.style.right = (100 - percent) + "%";
        amountRight.innerHTML = _this.value;
        $('.textpriceright').val(_this.value);
        range.style.right = (100 - percent) + "%";
        _this.style.zIndex  = 3;
    }
    setRightValue();
    inputLeft.addEventListener("input", setLeftValue);
    inputRight.addEventListener("input", setRightValue);
    $('.textpriceleft').on("change",function(e){
        $('.price-left').val($(this).val());       
        var _this = inputLeft,
            min = parseInt(_this.min),
            max = parseInt(_this.max);
        _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
        var percent = ((_this.value - min) / (max - min)) * 100;    
        thumbLeft.style.left = percent + "%";
        range.style.left = percent + "%";
        if($(this).val().length == 0){
        $(this).val($(this).attr('min'));
        thumbLeft.style.left = 0+'%';
        range.style.left = 0+ "%";
        $('.price-left').val(0);  
        }
    });
    $('.textpriceright').on("change",function(e){
        $('.price-right').val($(this).val());
        //setRightValue();
        var _this = inputRight,
            min = parseInt(_this.min),
            max = parseInt(_this.max);
        _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
        var percent = ((_this.value - min) / (max - min)) * 100;
        thumbRight.style.right = (100 - percent) + "%";
        range.style.right = (100 - percent) + "%";
        _this.style.zIndex  = 3;
        if($(this).val().length == 0){
        $(this).val(Math.round($(this).attr('max')));
        thumbRight.style.right = 0+'%';
        range.style.right = 0+ "%";
        $('.price-right').val(Math.round($(this).attr('max')));      
        }
    });
    }
    if(document.querySelector('.range-wrap')){
    filterprice();

}
    
